import React from "react";
import DefaulHeader2 from "./header";
import Footer from "./footer";

const Layout = ({ children }) => {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <DefaulHeader2 />

      <main style={{ flex: 1, boxSizing: "border-box" }}>
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default Layout;